jQuery(function ($) {
	var sliders = $('.slider-carousel-a');

  sliders.each(function() {
  	const items = $(this).attr("data-items").split(",");
  	const dataTagePadding = parseInt($(this).attr("data-stage-padding"));

  	if($(this).attr("data-arrow-color") == "white") {
  		navText = [
	      '<img  src="/wp-content/themes/crecer/assets/img/icons/slider-arrow-left-white.png" alt="">',
	      '<img src="/wp-content/themes/crecer/assets/img/icons/slider-arrow-right-white.png" alt="">',
	    ];
  	} else {
  		navText = [
	      '<img  src="/wp-content/themes/crecer/assets/img/icons/slider-arrow-left.png" alt="">',
	      '<img src="/wp-content/themes/crecer/assets/img/icons/slider-arrow-right.png" alt="">',
	    ]
  	}

    const slider_speed =  3000;//$(this).attr('slider-speed');

    $(this).find('.owl-slide').removeClass('d-none')

    $(this).owlCarousel({
    	stagePadding: dataTagePadding,
      loop: true,
      nav:true,
      margin:20,
      dots:true,
      autoplay: false,
      autoplayTimeout: slider_speed,
      autoplayHoverPause:true,           
	    navText: navText,
	    responsive:{
	        0:{
	            items: items[0],
	            nav:true,
							touchDrag: false,
	        },
	        600:{
	            items: items[1],
	            nav:false
	        },
	        1200:{
	            items: items[2],
	            nav:true,
	            loop:false
	        },
	        1400:{
	            items: items[3],
	            nav:true,
	            loop:false
	        }
	    }
    });        	
  })

	
});